export default "__VITE_ASSET__06f86380__"